<div class="col-lg-12 row p-4">
    <div class="card p-3">
        <h5 class=" mb-0 text-secondary"> {{'ReportInformation' | translate}}</h5>
        <hr class="mb-3" />
        <div class="row">
            <div class="form-group mt-3">
                <div class="col-lg-4 mt-3">
                    <div style="display: flex; flex-wrap: nowrap; height: 30px">
                        <label for="Date"> {{'ReportDate' | translate}} </label>
                        <span *ngIf="!reportDate" class="alert" style="color: red;white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px;">
                          <div>*</div>
                        </span>
                    </div>
                    <datepicker [(maxHijri)]="currentDate"  [(maxGreg)]="currentDate" [(selectedDate)]="currentDate" (selectedDateChange)="SelectedDateChange($event);"  [selectedDateType]="2"></datepicker>

                    <!-- <input type="date" class="form-control" [(ngModel)]="reportDate" /> -->
                </div>
            </div>
            <div class="form-group row">
                <div class="col-lg-4 mt-3">
                    <label for="CommercialRegistrationNo">{{'ReportNumber' | translate}}</label>
                    <input type=" text" class="form-control" [(ngModel)]="reportNumber" />
                </div>
                <div class="col-lg-4 mt-3">
                    <label>{{'ReportType' | translate}}</label>
                    <!-- <ng-select></ng-select> -->
                    <ng-select [items]="reporttypesList" [(ngModel)]="reportTypeId" [multiple]="false" [clearable]="false"
                    bindLabel="text" bindValue="id"></ng-select>
  
                </div>
                <div class="col-lg-4  mt-3">
                    <label for="CRType" >{{'ReporterAddress' | translate}}</label>
                    <input type="text" class="form-control" [(ngModel)]="address" />

                </div>
                <!-- <div class="col-lg-4  mt-3">
                    <label for="CRStatus">{{'ReportClassification' | translate}} </label>
                    <ng-select></ng-select>


                </div> -->
            </div>

            <div class="form-group row">
                <div class="col-lg-4  mt-3">
                    <label for="CRType" >{{'ReporterName' | translate}}</label>
                    <input type="text" class="form-control" [(ngModel)]="reporterName" />

                </div>
                

                <div class="col-lg-4  mt-3">
                    <label for="CRStatus">{{'Nationality' | translate}}</label>
                    <ng-select id="Nationality"
                    required
                    #Nationality="ngModel"
                    class="form-control-select"
                    [(ngModel)]="reporterNationalityId"
                    [ngModelOptions]="{ standalone: true }"
                    placeholder="{{ 'Nationality' | translate }}"  >

             <ng-option *ngFor="let na of NationalityList" [value]="na.id">
                 <i class="flag-icon flag-icon-{{na.more}}"></i>
                 <span>{{na.text}} </span>
             </ng-option>
         </ng-select>
                </div>
                <div class="col-lg-4 mt-3">
                    <label for="RelationshipWithTheFacility">{{'RelationshipWithTheFacility' | translate}}</label>
                    <ng-select [items]="reporterRelationList" [(ngModel)]="reporterRelationId" [multiple]="false" [clearable]="false"
                    bindLabel="text" bindValue="id"></ng-select>
                </div>

            </div>




            <div class="form-group  row">
                <div class="col-lg-4 mt-3">
                  <label>{{'ReporterNationalityType' | translate}}</label>
                    <!-- <div class="divformlabel">

                    <span
                    *ngIf="identityTypes.invalid"
                    class="alert"
                    style="
                      color: red;
                      white-space: nowrap;
                      line-height: 0;
                      padding: 0;
                      margin-top: 8px;
                    "
                  >
                    <div *ngIf="identityTypes.errors?.required">*</div>
                  </span></div> -->
                    <ng-select  id="identityTypes"
                    required
                    #identityTypes="ngModel" [items]="reporterNationalTypeList" [(ngModel)]="reporterNationalTypeId" [multiple]="false" [clearable]="false"
                    bindLabel="text" bindValue="id"></ng-select>
                </div>
                <div class="col-lg-4 mt-3">
                  <label>
                    {{ "ReporterNationality" | translate }}
                  </label>
                    <!-- <div class="divformlabel">
                        <span
                          *ngIf="ReporterNationality.invalid"
                          class="alert"
                          style="
                            color: red;
                            white-space: nowrap;
                            line-height: 0;
                            padding: 0;
                            margin-top: 8px;
                          "
                        >
                          <div *ngIf="ReporterNationality.errors?.required">
                            *
                          </div>
                        </span>
                        <span
                          *ngIf="ReporterNationality.invalid"
                          class="alert"
                          style="
                            color: red;
                            white-space: nowrap;
                            line-height: 0;
                            padding: 0;
                            margin-top: 8px;
                          "
                        >
                          <div *ngIf="ReporterNationality.errors?.minlength">
                            {{"IdentityNumberMustBe10Number" | translate}}
                          </div>
                        </span>
                      </div> -->
                      <input 
                      required
                      #ReporterNationality="ngModel"
                      minlength="10"
                      maxlength="10"
                      name="ReporterNationality"
                      id="ReporterNationality"
                      type="text" class="form-control" (keypress)="numberOnly($event)" [(ngModel)]="reporterNationalId" />

                </div>
                <div class="col-lg-4 mt-3">
                    <div class="divformlabel">
                        <label for="mobile">{{'MobileNumber'|translate}} </label>
                          <span *ngIf="Mobile.invalid" class="alert" style="color: red; white-space: nowrap;line-height: 0; padding: 0; margin-top: 8px;">
                              <!-- <div *ngIf="Mobile.errors?.required">
                                  *
                              </div> -->
                              <div *ngIf="Mobile.errors?.pattern">
                                  {{'ThisMobileIsInvalid' | translate}}
                              </div>
                          </span>
                        </div>
                        <input required   #Mobile="ngModel" pattern="^(009665|9665|\+9665|05|5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$"  placeholder="{{'MobileNumber'|translate}}" type="text" [(ngModel)]="reporterMobileNumber" [ngModelOptions]="{standalone: true}" class="form-control" name="mobile" id="mobile" [ngModelOptions]="{standalone: true}" >
                    
                </div>
                
            </div>

            <div class="form-group  row">

                
                <div class="col-lg-4 mt-3">
                    <div class="divformlabel">
                        <label for="Mobile2">{{'MobileNumber'|translate}} 2</label>
                          <span *ngIf="Mobile2.invalid" class="alert" style="color: red; white-space: nowrap;line-height: 0; padding: 0; margin-top: 8px;">
                              <!-- <div *ngIf="Mobile2.errors?.required">
                                  *
                              </div> -->
                              <div *ngIf="Mobile2.errors?.pattern">
                                  {{'ThisMobileIsInvalid' | translate}}
                              </div>
                          </span>
                        </div>
                        <input required   #Mobile2="ngModel" pattern="^(009665|9665|\+9665|05|5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$"  placeholder="{{'MobileNumber'|translate}}" type="text" [(ngModel)]="reporterMobileNumber2" [ngModelOptions]="{standalone: true}" class="form-control" name="Mobile2" id="Mobile2" [ngModelOptions]="{standalone: true}" >
                 
                </div>
                <div class="col-lg-12  mt-3">
                    <label for="ReportDetails" >{{'ReportDetails' | translate}}</label>
                    <span *ngIf="ReportDetails.invalid" class="alert" style="
                    color: red;
                    white-space: nowrap;
                    line-height: 0;
                    padding: 0;
                    margin-top: 8px;
                  ">
                      <span *ngIf="ReportDetails.errors?.required">*</span>
                  </span>
                    <textarea class="form-control" type="text"
                    name="ReportDetails"
                    placeholder="{{'ReportDetails' | translate}}"
                    [(ngModel)]="reportDetails" #ReportDetails="ngModel" required></textarea>
                </div>
            </div>





        </div>
        
        <div class="col-lg-3 m-auto">
            <!--    *ngIf="caseService.case && caseService.case.settings.allowEditBasicData" -->
            <button
            [disabled]="ReportDetails.invalid "     (click)="SaveCaseReport()"
                    class="btn btn-primary mt-3"
                    style="width: 100%"
                    type="button">
                {{ "Save" | translate }}
            </button>
        </div>
    </div>



</div>